<section class='content'>
  <div class="card" style="padding: 25px;">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
<!-- Row 2 -->
    <div class="row">

      <div class="col-3">
          <mat-label>Select Input Type</mat-label>
          <mat-select [(ngModel)]="selected_input_type" class="main-border-class">
            <mat-option *ngFor="let input_type of input_type_list" [value]="input_type">{{input_type}}</mat-option>
          </mat-select>
      </div>

      <div class="col-3" *ngIf="selected_input_type === 'Business'">
        <mat-label>Business Code</mat-label>
        <input type="number" [(ngModel)]="business_code" class="main-border-class" />
      </div>

      <div class="col-3" *ngIf="selected_input_type === 'Business Type'">
        <mat-label>Select Business Type</mat-label>
        <mat-select multiple [(ngModel)]="selected_business_types" class="main-border-class">
          <mat-option *ngFor="let business_type of business_type_list" [value]="business_type.id">{{business_type.name}}</mat-option>
        </mat-select>
      </div>

      <div class="col-3" *ngIf="selected_input_type === 'Business Type'">
        <mat-label>Select Zone</mat-label>
        <mat-select multiple [(ngModel)]="selected_zones" class="main-border-class">
          <mat-option *ngFor="let zone of zone_list" [value]="zone.id">{{zone.name}}</mat-option>
        </mat-select>
      </div>

      <div class="col-2" *ngIf="selected_input_type === 'Business'">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 9%;border-radius: 5px;background: blanchedalmond;"
          [disabled]="business_code == null">Get</button>
      </div>

      <div class="col-2" *ngIf="selected_input_type === 'Business Type'">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 9%;border-radius: 5px;background: blanchedalmond;"
          [disabled]="selected_business_types == null">Get</button>
      </div>

      <div class="col-2" *ngIf="!is_document_available">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
        </mat-progress-spinner>
      </div>

      <div class="col-2" *ngIf="document_file!== null">
        <button mat-button class="button-class" (click)="downloadClicked()" style="margin-top: 25px;"><i class="material-icons" >
            get_app
          </i> Download Excel</button>
      </div>

    </div>
  </div>
</section>
